import React, { useEffect } from 'react';
import "./LoadingCircle.css"

function Box ({children}) {
    return (
        <div className="box">{children}</div>
    )
}

export default function LoadingCircle() {

    return (
           <div className="circlediv">
               <div className="circleact1 animation1 zoom1"></div>
               <div className="circleact2 animation2"></div>
               <div className="middleCircle middle-animation"></div>
               <div className="circleact3 animation3"></div>
               <div className="circleact4 animation4"></div>
           </div>

    )
}